import _ from 'lodash';
import React, { Component } from 'react';

import SessionList from './SessionList';

export class Schedule extends Component {
  renderUpcomingDates() {
    // Group sessions by date
    let sessionsByDate = {};
    this.props.sessions.forEach(session => {
      let dateOnly = new Date(session.startsAt);
      dateOnly.setHours(0, 0, 0, 0);
      // Need numeric index otherwise object sorts on weekday
      const timestamp = dateOnly.getTime();
      if (typeof sessionsByDate[timestamp] === 'undefined') {
        sessionsByDate[timestamp] = [];
      }
      sessionsByDate[timestamp].push(session);
    });

    const dateOptions = {
      weekday: 'long',
      year: 'numeric', // @todo show year if not the current year
      month: 'short',
      day: 'numeric'
    };
    const locale = 'en-NZ';

    return _.map(sessionsByDate, (sessions, timestamp) => {
      const date = new Date(parseInt(timestamp, 10));
      return (
        <div className="card mb-3" key={timestamp}>
          <div className="card-header">
            {date.toLocaleDateString(locale, dateOptions)}
          </div>
          <SessionList
            sessions={sessions}
            allClients={this.props.allClients}
            allLocations={this.props.allLocations}
            showDates={false}
          />
        </div>
      );
    });
  }

  render() {
    return (
      <div className="col-md-9 content">
        {this.renderUpcomingDates()}
        <br />
        <br />
      </div>
    );
  }
}

export default Schedule;



// WEBPACK FOOTER //
// ./src/modules/sessions/components/Schedule.js